import React, { useEffect, useRef, useState } from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
// eslint-disable-next-line max-len
import type { ProductComparisonProductHighlights as ProductComparisonProductHighlightsType } from '../../../../.storyblok/types/255103/storyblok-components';
import Col from '../../FlexboxGrid/Col';
import Row from '../../FlexboxGrid/Row';

interface ProductComparisonProductHighlightsProps {
  blok: ProductComparisonProductHighlightsType;
}

const ProductComparisonProductHighlights = ({ blok }: ProductComparisonProductHighlightsProps) => {
  const [fixedScrollThreshold, setFixedScrollThreshold] = useState(false);
  const sentinelRef = useRef(null);

  // set fixed scroll header
  useEffect(() => {
    const sentinel = sentinelRef.current;

    if (!sentinel) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = !entry?.isIntersecting && entry && entry.boundingClientRect.bottom < 0;
        setFixedScrollThreshold(scrolledPast ?? false);
      },
      { threshold: 0 },
    );

    observer.observe(sentinel);

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full" {...storyblokEditable(blok)}>
      {/* @ts-expect-error Row is not yet refactored */}
      <Row>
        {/* @ts-expect-error Col is not yet refactored */}
        <Col xs={4} md={5} lg={6}>
          <StoryblokComponent
            blok={blok.productComparisonProductLeft.find((el) => el) ?? {}}
            column="left"
            fixedScrollThreshold={fixedScrollThreshold}
          />
        </Col>
        {/* @ts-expect-error Col is not yet refactored */}
        <Col xs={4} md={5} lg={6}>
          <StoryblokComponent
            blok={blok.productComparisonProductRight.find((el) => el) ?? {}}
            column="right"
            fixedScrollThreshold={fixedScrollThreshold}
          />
        </Col>
      </Row>

      {/* to detect user scroll */}
      <div className="invisible h-[1px]" ref={sentinelRef}></div>
    </div>
  );
};

export default ProductComparisonProductHighlights;
